import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { getBrandConfig } from './brandConfig';

const brandConfig = getBrandConfig();
const brandTitle = (brandConfig.appTitle || brandConfig.name || 'Discador.NET').replace(/[_-]+/g, ' ');
document.title = `${brandTitle} - IA de Voz`;

// Aplica o favicon da white label resolvida. Se a marca não definir faviconUrl,
// getBrandConfig() já retorna o fallback '/favicon.ico' (defaultConfig), então o
// favicon padrão do deploy default permanece intacto.
const faviconUrl = brandConfig.faviconUrl;
if (faviconUrl) {
  let iconLink = document.querySelector("link[rel~='icon']");
  if (!iconLink) {
    iconLink = document.createElement('link');
    iconLink.rel = 'icon';
    document.head.appendChild(iconLink);
  }
  iconLink.href = faviconUrl;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
